<button
  [disabled]="btnState === 'disabled'"
  class="zf-btn"
  [ngStyle]="{width: buttonWidth + 'px', height: buttonHeight + 'px', background: colorFill}"
  (click)="handleClick()"
  [ngClass]="buttonClass"
>
  <monorepo-zf-icon
    *ngIf="iconProperties"
    [iconName]="iconProperties.iconName"
    [isActive]="(btnState === 'active')"
    [iconClasses]="iconProperties.iconClasses || []"
  >
  </monorepo-zf-icon>
  <zf-text>
    <ng-content></ng-content>
  </zf-text>
</button>
